import { STATE_META, type ScraperState } from '../lib/scraperState';

export function StatusDot({ state }: { state: ScraperState }) {
  const meta = STATE_META[state];
  return (
    <span
      className={`sdot ${meta.live ? 'live' : ''}`}
      style={{ background: meta.dot }}
      title={meta.label}
    />
  );
}

export function StatusPill({ state }: { state: ScraperState }) {
  const meta = STATE_META[state];
  return <span className={`pill ${meta.pill} dot`}>{meta.label}</span>;
}
